<template>
    <tr class="applicant-list">
      <td style="min-width: 30px!important;">
        <input
                type="checkbox"
                v-bind:value="applicantData.id"
                @change="checkUncheckJobseeker(applicantData.id)"
                :checked="isChecked" style="margin-top:4px;"
        />
      </td>
      <td
        style="padding-left:0px !important; min-width: 40px !important; max-width: 50px !important;"
        @click="toggleIndividualContact(applicantData)"
      >{{rowNumber}}</td>
      <template>
        <td
          class="td-date"
            @click="toggleIndividualContact(applicantData)"
          v-if="!isReviewer"
        >{{reviewListAddedDate}}</td>
        <td
          class="td-date"
          @click="toggleIndividualContact(applicantData)"
        >
        <div class="date-container d-flex flex-column align-items-center text-center">
          <span>{{ joinedDate }}</span>
          <span>{{  assignedUser }}</span>
          <img 
            v-if="applicantData.companyFrom === '自社'" 
            :src="require('@/assets/images/Group 2418.svg')" 
            alt="自社HP経由登録"
            class="company-source-label"
          />
          <!-- <span v-if="applicantData.companyFrom === '自社'" class="company-source">自社HP経由登録</span> -->
        </div>
        </td>
        <td
          class="text-left"
          style="min-width: 120px !important; max-width: 120px !important;"
          @click="toggleIndividualContact(applicantData)"
        >
          <div class="td-container d-flex flex-column">
            <span
              class="client-name"
              v-html="getHighlightedContent(['full_name', 'last_name'], `${applicantData.last_name} ${applicantData.name}`)"
              style="cursor: none;font-weight: bold;"
            ></span>
            <span>{{applicantData.age}} 歳/ {{employment.lastYearIncome}} 万円</span><br/>
            <span  v-html="getHighlightedContent(['graduation_school_name'], applicantData.education.instituteName)"/>
          </div>
        </td>
  
        <td
          class="text-left block-with-text"
          style="min-width: 150px !important; max-width: 150px !important;"
          @click="toggleIndividualContact(applicantData)"
        >
        <div class="td-container d-flex flex-column" @click="toggleIndividualContact(applicantData)">
          <span v-html="getHighlightedContent(['recent_registered_company_name'], employment.lastCompany)"></span><br/>
          <span> {{employment.lastJob.title}}/
            <br />
          ( {{employment.lastJob.child.title}} )</span>
        </div>
  
      </td> 
  
      <td class="text-left"  style="min-width: 250px !important; max-width: 250px !important;" @click="toggleIndividualContact(applicantData)">
        <span class="scouted-jobs" v-for="job in applicantData.markedjobseekers" :key="job.id">{{jdTitle(job)}} <br/></span>
      </td>

      <td class="text-center" @click="toggleIndividualContact(applicantData)">
        <div class="d-flex align-items-center justify-content-center">
          <span class="scout-type" v-if="applicantData.scoutType || applicant.scoutType">{{ applicantData.scoutType || applicant.scoutType }}</span>
        </div>
      </td>
      <td class="text-center" @click="toggleIndividualContact(applicantData)">
        {{ applicantData.status }}
      </td>

      <td class="text-center">
        <div class="d-flex flex-column align-items-center">
          <!-- <ScoutButton /> -->
          <button class="contact-btn" @click="toggleIndividualContact(applicantData)">送信に進む</button>
          <button class="request-judgment request-judgment-2" @click="toggleScout(applicantData)">スカウト対象外にする</button>
        </div>
      </td>

      <!-- <td>Read/Unread</td> -->
    </template>
      <ProfileModal
        :applicantId="applicantData.id"
        :applicantIndex="applicantIndex"
        :isFavorite="applicantData.isFavorite"
        :isInterview="applicantData.isInterview"
        :applicantdata="applicantData"
        :showProfileModal="showProfileModal"
        :isPreview="isPreview"
        v-on:hideModal="hideProfile"
      />
      <ReviewListPopup 
        ref="reviewListPopup" 
        :applicant="applicantData"
        :showReviewListModal="showReviewListModal"
        @hideModal="hideReviewList"
      />

      <IndividualContactModal
        v-if="showIndividualContact"
        :applicantIndex="applicantIndex"
        :applicant_id="applicantData.id"
        :showIndividualContact="showIndividualContact"
        :email="applicantData.email"
        @cancel="toggleIndividualContact"
      />

    </tr>
  </template>
  
  <script>
  import Favorite from '@/components/dashboard/applicants/Favorite.vue';
  import Interview from '@/components/dashboard/applicants/Interview.vue';
  import ColorCategory from '@/components/dashboard/applicants/ColorCategory.vue';
  import Memo from '@/components/dashboard/applicants/Memo.vue';
  import ProfileModal from '@/components/dashboard/applicants/profile/ProfileModal.vue';
//   import StatusDropDown from '@/components/dashboard/StatusDropDown.vue';
  import ScoutButton from '@/components/dashboard/ScoutButton.vue';
  import ReviewListPopup from '@/components/dashboard/ReviewListPopup.vue';
  import IndividualContact from '../contacts/IndividualContact.vue';
  import IndividualContactModal from '../contacts/IndividualContactModal.vue';
  import Api from '@/config/api';
  import ApiService from '@/service/apiService';
  import moment from 'moment';
  import { mapGetters, mapState, mapMutations } from 'vuex';
  
  export default {
    name: 'ScoutApplicantsRow',
    components: {
      Memo,
      Favorite,
      Interview,
      ProfileModal,
    //   StatusDropDown,
      ColorCategory,
      ScoutButton,
      ReviewListPopup,
      IndividualContact,
      IndividualContactModal
    },
    props: [
      'applicant',
      'applicantIndex',
      'rowNumber',
      // 'isChecked',
      'isPreview'
    ],
    data() {
      return {
        rowColor: this.applicant.color,
        applicantData: this.applicant,
        showProfileModal: false,
        loading: false,
        isCheckSome: false,
        showReviewListModal: false,
        showIndividualContact: false,
      };
    },
    computed: {
      ...mapGetters({
        getMenus: 'getMenus',
        isReviewer: 'isCreateReviewUser',
        isAdmin: 'currentUserIsAdmin',
        statusColorMap: 'getStatusColorMap'
      }),
      ...mapState({
        jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      }),
      isChecked() {
        return this.jobseekerIds.includes(this.applicant.id)
      },
      bgColor() {
        let color;
        if (this.rowColor == '#fff') {
          color = '#fbfcff';
        } else {
          color = this.rowColor;
        }
        return `background-color: ${color}`;
      },
      joinedDate() {
          return moment(this.applicantData.scoutedDate)
          .utcOffset('+0900')
          .format('YYYY-MM-DD');    
      },
      assignedUser() {
        return (this.applicantData && this.applicantData.scoutedUser) || (this.applicant && this.applicant.scoutedUser) || '';
      },
      reviewListAddedDate(){
        return moment(this.applicantData.reviewListAddedDate)
          .utcOffset('+0900')
          .format('YYYY-MM-DD');
      },
      checked() {
        return this.isChecked ? 'checked' : '';
      },
      employment() {
        return this.applicantData.employment;
      },
      imagePath() {
        return this.applicantData.imagePath;
      },
      colorClass() {
        const status = this.applicantData.status;
        const colorMap = this.statusColorMap;
        for(let color in colorMap){
          if(colorMap[color].includes(status)){
            return color;
          }
        }
        return '';
      },
    },
  
    methods: {
      ...mapMutations({
        mutateApplicantsAfterFav: 'mutateApplicantsAfterFav',
        mutateApplicantsAfterInterview: 'mutateApplicantsAfterInterview',
        checkUncheckJobseeker: 'checkUncheckJobseeker',
        setReloadApplicants: 'setReloadApplicants',
        setScoutedJd: 'setScoutedJd'
      }),
      toggleIndividualContact() {
        this.showIndividualContact = !this.showIndividualContact;
      },
      // jobTitle(job) {
      //   let jobTitle = job.jobDetails.job_title;
      //   return jobTitle.length > 15 ? jobTitle.substring(0, 15) + '...' : jobTitle;
      // },
      jdTitle(jd){
        return jd.jobDescriptionTitle;
      },
      //remove scout
      async toggleScout() {
        try {
          await ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
            status: '未確認'
          });
          this.setReloadApplicants(true);
        } catch (error) {
          console.log(error);
          this.parseErrorResponse(error.response);
        }
      },
      requestJudgement() { 
        this.showReviewListModal = true;
      },
      hideReviewList() {
        this.showReviewListModal = false;
      },
      getHighlightedContent(paths, originalText) {
        if (!this.applicantData.highlights || !this.applicantData.highlights.length) {
          return originalText;
        }
  
        // Special handling for name fields
        if (paths.includes('last_name') || paths.includes('full_name')) {
          let highlightedText = originalText;
  
          const nameHighlights = this.applicantData.highlights.filter(h => 
            paths.includes(h.path) && h.texts && h.texts.length
          );
  
          for (let highlight of nameHighlights) {
            // Sort hit texts by length (longest first) to handle overlapping matches
            const hitTexts = highlight.texts
              .filter(t => t.type === 'hit')
              .sort((a, b) => b.value.length - a.value.length);
  
            // Process each hit text separately
            for (let hitText of hitTexts) {
              const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
              highlightedText = highlightedText.replace(
                searchRegex, 
                match => `<span class="highlight-hit">${match}</span>`
              );
            }
          }
  
          return highlightedText;
        }
  
        // Regular handling for other fields
        const highlights = this.applicantData.highlights.filter(h => paths.includes(h.path));
        if (highlights.length === 0) {
          return originalText;
        }
  
        let highlightedText = originalText;
  
        for (let highlight of highlights) {
          // Sort hit texts by length (longest first) to handle overlapping matches
          const hitTexts = highlight.texts
            .filter(t => t.type === 'hit')
            .sort((a, b) => b.value.length - a.value.length);
  
          // Process each hit text separately
          for (let hitText of hitTexts) {
            const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
            highlightedText = highlightedText.replace(
              searchRegex, 
              match => `<span class="highlight-hit">${match}</span>`
            );
          }
        }
  
        return highlightedText;
      },
      escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      },
      formatHighlightText(texts) {
        return texts.map(text => {
          if (text.type === 'hit' || text.type === 'text') {
            return `<span class="highlight-hit">${text.value}</span>`;
          }
          return text.value;
        }).join('');
      },
      changeRowColor(color) {
        this.rowColor = color;
      },
      toggleFavorite(applicant) {      
        this.loading = true;
        const method = applicant.isFavorite ? 'delete' : 'put';
        ApiService[method](Api.endpoints.FAVORITE(applicant.id))
          .then(({ data }) => {
            // this.applicantData = data.data;
            this.mutateApplicantsAfterFav(data.data);
          })
          .catch(({ response }) => this.parseErrorResponse(response))
          .then(() => {
            this.loading = false;
          });
      },
  
      toggleInterview(applicant) { 
        this.loading = true;
        const method = applicant.isInterview ? 'delete' : 'put';
        ApiService[method](Api.endpoints.INTERVIEW(applicant.id))
                .then(({ data }) => {
          // this.applicantData = data.data;
        this.mutateApplicantsAfterInterview(data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
            this.loading = false;
        });
      },
      hideProfile() {
        this.showProfileModal = false;
      },
      statusChanged(status) {
        this.applicantData.status = status;
      },
    },
    watch: {
      'applicant': {
        handler(newApplicant) {
          // Only update fields that need highlighting
          const fieldsToUpdate = {
            highlights: newApplicant.highlights,
            last_name: newApplicant.last_name,
            name: newApplicant.name,
            education: newApplicant.education,
            employment: newApplicant.employment
          };
          
          Object.assign(this.applicantData, fieldsToUpdate);
        },
        deep: false
      },
      'applicant.status': function () {
        this.applicantData.status = this.applicant.status;
      },
      'applicant.isFavorite': function () {
        this.applicantData.isFavorite = this.applicant.isFavorite;
      },
      'applicant.isInterview': function () {
        this.applicantData.isInterview = this.applicant.isInterview;
      },
      'applicant.memo': function () {
        this.applicantData.memo = this.applicant.memo;
      },
      'applicant.color': function(){
        this.rowColor = this.applicant.color;
        this.applicantData.color = this.applicant.color;
      },
      'applicant.scoutedUser': function () {
        this.applicantData.scoutedUser = this.applicant.scoutedUser;
      },
      'applicant.scoutType': function () {
        this.applicantData.scoutType = this.applicant.scoutType;
      }
  
    },
  };
  </script>
  
  <style scoped>
  .scout-type {
    width: 120px;
    display: block;
    background: #787878;
    text-align: center;
    /* padding: 10px; */
    height: 32px;
    padding: 5px;
    color: white;
    border-radius: 3px;
  }
  .scouted-jobs {
    /* font-size: 12px; */
    color: #036AC9;
  }
  .note-btn-grp button {
    width: 20px;
  }
  
  </style>
  <style>
  .contact-btn {
    width: 159px;
    height: 42px;
    border-radius: 30px;
    border: 1px solid #eb5757;
    background: #eb5757;
    color: white;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 10px;
  }

  .contact-btn :hover {
    background: white;
    color: #eb5757;
  }

  .contact-btn :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .request-judgment-2 {
    width: 159px !important;
    height: 25px !important;
  }

  .company-source {
    background-color: #006C6B;
    padding: 4px 6px;
    border-radius: 4px;
    font-size: 0.85em;
    color: #fff;
    height:24px;
    width: fit-content;
    position: relative;
    margin: auto;
    /* margin-right: 10px; */
    display: inline-block;
  }
  
  .company-source::after {
    content: '';
    position: absolute;
    right: -10px; /* Adjusted to make space for the full triangle */
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 10px solid transparent; /* Larger triangle */
    border-bottom: 10px solid transparent; /* Larger triangle */
    border-left: 10px solid #006C6B; /* Match the background color */
  }
  .highlight-hit{
    background-color: #ffd700;
    padding: 0 2px;
    border-radius: 2px;
    font-weight: 500;
  }
  .pink button {
    color: #fff;
    background-color: #b97070;
    border-color: #b97070;
  }
  .grey button {
    color: #fff;
    background-color: #ab8371;
    border-color: #ab8371;
  }
  .green button {
    color: #fff;
    background-color: #5bb55b;
    border-color: #5bb55b;
  }
  .lightblue button {
    color: #fff;
    background-color: #7070af;
    border-color: #7070af;
  }
  .lightgreen button {
    color: #fff;
    background-color: #7ba27b;
    border-color: #7ba27b;
  }
  .red button {
    color: #fff;
    background-color: #ab8371;
    border-color: #ab8371;
  }
  .yellow button{
    color: #000;
    background-color: #ffea00;
    border-color: #ffea00;
  }
  .applicant-list {
    border: 2px solid transparent;
    border-left: solid 2px transparent;
    border-right: solid 2px transparent;
  }
  .applicant-list td {
    padding: 5px 7px !important;
  }
  
  .applicant-list:hover {
    /*border-right: solid 2px #0e0e0e6b;*/
    /*border-left: solid 2px #0e0e0e6b;*/
    /*box-shadow:rgba(50, 52, 93, 0) 1px 0px 20px 4px inset, rgb(0 0 0 / 10%) 0px 0px 20px 0px inset;*/
  
    /*-webkit-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
    /*-moz-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
    /*box-shadow: */
    box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
    z-index: 1;
    /*background-color: #f0f5f7!important;*/
  
    border: 2px solid #036d6c;
    /*background-color: #F0F8FD!important;*/
  
  }
  .pink button:hover,
  .show.pink button {
    background-color: white !important;
    color: black !important;
    border-color: #b97070 !important;
  }
  .grey button:hover,
  .show.grey button {
    background-color: white !important;
    color: black !important;
    border-color: #ab8371 !important;
  }
  .green button:hover,
  .show.grey button {
    background-color: white !important;
    color: black !important;
    border-color: #5bb55b !important;
  }
  .lightblue button:hover,
  .show.lightblue button {
    background-color: white !important;
    color: black !important;
    border-color: #7070af !important;
  }
  .lightgreen button:hover,
  .show.lightgreen button {
    background-color: white !important;
    color: black !important;
    border-color: #7ba27b !important;
  }
  
  .yellow button:hover,
  .show.yellow button {
    background-color: white !important;
    color: black !important;
    border-color: #ffea00 !important;
  }
  
  .wrapword {
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* css-3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
    word-break: break-all;
    white-space: normal;
  }
  
  .block-with-text {
    /* hide text if it more than N lines  */
    overflow: hidden;
    /* for set '...' in absolute position */
    position: relative; 
    /* use this value to count block height */
    line-height: 1.2em;
    /* max-height = line-height (1.2) * lines max number (3) */
    max-height: 3.6em; 
    /* fix problem when last visible word doesn't adjoin right side  */
    text-align: justify;  
    /* place for '...' */
    margin-right: -1em;
    padding-right: 1em;
  }
  .text-center {
    min-width: 50px !important;
  }
  .text-left {
    text-align: left !important;
  }
  
  .applicant-list >td:hover {
    /*font-weight:600!important;*/
    /*text-decoration: underline;*/
    color:#1e6d6b!important;
  }
  .note-btn-grp >.btn-heart i:hover{
    color:#aba2a2!important;
  }
  .fa-sticky-note:hover{
    color:#aba2a2!important;
  }
  .client-listing-detail table td:first-child {
    min-width:25px!important;
  }
  .client-listing-detail table td:last-child {
    min-width:25px!important;
  }
  
  </style>
  